import { REQUEST } from 'Stores'
import { GENERATE_CODE, RESET_2FA, VERIFY_CODE, VERIFY_CODE_RESET } from './constants'

export function reset2fa() {
  return {
    type: REQUEST(RESET_2FA)
  }
}

export function verifyCode(payload) {
  return {
    type: REQUEST(VERIFY_CODE),
    payload
  }
}

export function verifyCodeReset(payload) {
  return {
    type: REQUEST(VERIFY_CODE_RESET),
    payload
  }
}

export function generateCode() {
  return {
    type: REQUEST(GENERATE_CODE)
  }
}
